import { theme } from 'Assets/Styles/theme'

export default ({ props }) => {
  const accentColor = props.color || theme.colors.primary

  return {
    block: {
      padding: '12px 18px',
      borderRadius: '4px',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: '#eee',
      marginTop: '16px',
    },
    header: {
      fontSize: '16px',
      marginBottom: '8px',
      color: '#3B3B3B',
      display: 'flex',
      alignItems: 'center',
    },
    blockInfo: { color: '#3B3B3B', marginBottom: '16px' },
    button: {
      margin: '16px auto 10px',
      width: '400px',
      borderRadius: '4px',
      letterSpacing: '0.8px',
      filter: 'brightness(1)',
      textTransform: 'capitalize',
      transition: 'filter .3s',
      '&:not(:last-child)': {
        marginRight: '10px',
      },
      '&:hover': {
        backgroundColor: accentColor,
        filter: 'brightness(1.3)',
      },
      '&:disabled': {
        color: theme.colors.white,
        backgroundColor: accentColor,
        opacity: 0.3,
      },
      backgroundColor: accentColor,
      color: theme.colors.white,
    },
    disabled: {
      opacity: 0.4,
    },
    bold: {
      fontWeight: 'bold',
    },
    modalInfo: {
      '&:not(:first-child)': {
        marginTop: '16px',
      },
    },
  }
}
